// Material
import { useCallback } from 'react'
import { Box, InputBase } from '@mui/material'
import { SxProps, styled } from '@mui/material/styles'
import { LengthVerifier } from '$common/input/length-verifier'

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  ...theme.typography.subtitle3,
  backgroundColor: theme.palette.neutral000,
  padding: '8px 16px',
  borderRadius: '8px',
  width: '100%',
  border: `1px solid ${theme.palette.neutral300}`,
  caretColor: theme.palette.secondary.main,
  boxSizing: 'border-box',
  direction: 'inherit',

  '&.Mui-focused': {
    backgroundColor: theme.palette.neutral000,
    borderColor: theme.palette.primary500,
  },
  '&.Mui-error': {
    borderColor: theme.palette.error.main,
  },
  '& ::placeholder': {
    textAlign: 'right',
  },
}))

// TODO: Calculate dir based on value
export function MultilineInput({
  value,
  placeholder = '',
  maxLength = undefined,
  showMaxLength = false,
  onChange,
  sx,
  autoFocus = false,
  disabled = false,
  ...props
}: {
  placeholder?: string
  autoFocus?: boolean
  maxLength?: number
  showMaxLength?: boolean
  value: string
  onChange: (text: string) => unknown
  disabled?: boolean
  sx?: SxProps
}) {
  const handleInputChange = useCallback(
    (newValue: string) => {
      if (!maxLength || newValue.length <= maxLength) onChange(newValue)
    },
    [maxLength, onChange],
  )

  return (
    <>
      <Box sx={{ marginTop: '6px', marginBottom: '10px', ...sx }}>
        <StyledInputBase
          placeholder={placeholder}
          minRows={3}
          multiline
          value={value}
          error={value.length === maxLength}
          inputProps={{
            maxLength,
          }}
          onChange={({ target: { value: newValue } }) =>
            handleInputChange(newValue)
          }
          autoFocus={autoFocus}
          disabled={disabled}
          {...props}
        />
      </Box>

      {showMaxLength && maxLength && (
        <LengthVerifier maxLength={maxLength} value={value} />
      )}
    </>
  )
}
